import { useState } from "react";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import {WorkingHours} from "./WorkingHours"

export const Header = () => {
  const { t } = useTranslation();
  const [curreentLanguage, setCurrentLanguage] = useState("bg");
  const handleLanguage = () => {
    if (curreentLanguage === "bg") {
      setCurrentLanguage("en");
      i18n.changeLanguage("en");
    } else {
      setCurrentLanguage("bg");
      i18n.changeLanguage("bg");
    }
  };

  return (
    <div className="header">
      <div className="header-left">
        <WorkingHours/>
      </div>
      <div className="header-right">
        <button onClick={handleLanguage} className="header-button">
          {t("lang")}
        </button>
      </div>
    </div>
  );
};
